import BadgeIcon from '@mui/icons-material/Badge';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Collapse, IconButton, Stack, TableCell, TableRow, Theme, Tooltip, Typography, useTheme } from '@mui/material';
import moment from 'moment';
import { useState } from 'react';
import { ScheduledTask } from '../../../../hooks/useMessageUsersScheduledSessions';
import { stripHtml, targetUsersName } from '../../../../utils/common';
import MessageUsersScheduledListRowDetails from './MessageUsersScheduledListRowDetails';
import MessageUsersScheduledListRowLocalMenu from './MessageUsersScheduledListRowLocalMenu';

const MessageUsersScheduledListRow = (props: { row: ScheduledTask; timezone: string; smallScreen: boolean }) => {
    const { row, timezone, smallScreen } = props;
    const theme: Theme = useTheme();

    const [open, setOpen] = useState(false);

    return (
        <>
            <TableRow
                key={row._id}
                sx={{
                    '&:last-child td, &:last-child th': { border: 0 },
                    cursor: 'pointer',
                    // tight left/right spacing
                    '& td': {
                        paddingLeft: 0.5,
                        paddingRight: 0.5,
                    },
                    // all cells except last one have no bottom border
                    '& td:not(:last-child)': {
                        opacity: row.inactive ? 0.5 : 1,
                        // transition for opacity
                        transition: theme.transitions.create('opacity', {
                            duration: theme.transitions.duration.standard,
                        }),
                    },
                }}
            >
                <TableCell padding="none" onClick={() => setOpen(!open)}>
                    <IconButton size="small">{open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}</IconButton>
                </TableCell>
                <TableCell onClick={() => setOpen(!open)}>{moment(row.scheduleDateTime).tz(timezone).format('LT')}</TableCell>
                <TableCell onClick={() => setOpen(!open)}>{targetUsersName(row.payload.usersType, {})}</TableCell>
                <TableCell
                    onClick={() => setOpen(!open)}
                    sx={{
                        display: { xs: 'none', sm: 'table-cell' },
                    }}
                >
                    <Stack direction="column" spacing={1} alignItems="flex-start" justifyContent="center" width={'100%'}>
                        <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start" width={'100%'}>
                            <Tooltip title="Name" placement="top">
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <BadgeIcon color="primary" sx={{ fontSize: '12pt' }} />
                                </div>
                            </Tooltip>
                            <Typography variant="inherit" color={row.payload.name ? 'textPrimary' : 'textSecondary'}>
                                {row.payload.name || 'No Name'}
                            </Typography>
                        </Stack>

                        <Typography
                            variant="body2"
                            component="div"
                            color="textSecondary"
                            sx={{
                                wordBreak: 'break-word',
                            }}
                        >
                            {stripHtml(row.payload.message)
                                .split('\n')
                                .map((i: string, key: number) => {
                                    return <div key={key}>{i}</div>;
                                })}
                        </Typography>
                    </Stack>
                </TableCell>
                <TableCell align="center">
                    <MessageUsersScheduledListRowLocalMenu scheduledTask={row} />
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell
                    style={{
                        paddingBottom: 1,
                        paddingTop: 0,
                        paddingLeft: 1,
                        paddingRight: 1,
                        backgroundColor: theme.palette.grey[50],
                        borderBottom: open ? `1px solid ${theme.palette.divider}` : 'none',
                    }}
                    colSpan={6}
                >
                    <Collapse
                        in={open}
                        timeout="auto"
                        unmountOnExit={true}
                        sx={{ maxWidth: { sm: theme.breakpoints.values.sm, md: theme.breakpoints.values.md } }}
                    >
                        {open && <MessageUsersScheduledListRowDetails row={row} timezone={timezone} smallScreen={smallScreen} />}
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

export default MessageUsersScheduledListRow;
